import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    links: {
      createNewBeneficiary: 'Add a beneficiary',
      createNewMandate: 'Authorize a mandate',
      createNewTransfer: 'Transfer money',
      seeBeneficiaries: 'Beneficiaries',
      seeMandates: 'Direct Debits',
      seeScheduledTransfers: 'Scheduled transfers',
    },
    title: 'Payments',
  },
  fr: {
    links: {
      createNewBeneficiary: 'Ajouter un•e bénéficiaire',
      createNewMandate: 'Autoriser un mandat',
      createNewTransfer: 'Effectuer un virement',
      seeBeneficiaries: 'Bénéficiaires',
      seeMandates: 'Prélèvements SEPA',
      seeScheduledTransfers: 'Virements programmés',
    },
    title: 'Paiements',
  },
});

export default locales;
